import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const Languages = ['en', 'it', 'fr']

i18n
  .use(Backend)
//    .use(LanguageDetector)
  .use(initReactI18next) // bind react-i18next to the instance
  .init({

    fallbackLng: 'en',
    debug: false,
    whitelist: Languages,
    react: {
        useSuspense: false
      },
      resources: {
      
        it: {
          translation: require('./locales/it/translation.json')
        },
        en: {
          translation: require('./locales/en/translation.json')
        },
        fr: {
          translation: require('./locales/fr/translation.json')
        }
      },

  })
  


export default i18n;